import { useContext } from 'react'
import { HomeStoreContext } from './HomeStoreProvider.rop'
const useHomeStoreRop = () => useContext(HomeStoreContext)
export default useHomeStoreRop
